import { formatNumber } from "helpers/system";
import Tooltip from "rc-tooltip";
import React, { useMemo } from "react";
import RouteDetails from "./actions/routeDetails";

const TollRoads = ({ tollRoads, modal, route }) => {
    const cost = tollRoads.reduce((sum, item) => sum + item.cost, 0);
    const groupedTollRoads = useMemo(() => {
        return (tollRoads || []).reduce((acc, item) => {
            if (!acc[item.tag]) {
                acc[item.tag] = { ...item };
            } else {
                acc[item.tag].distance += item.distance;
                acc[item.tag].cost += item.cost;
            }
            return acc;
        }, {});
    }, [tollRoads]);

    const showRouteInfo = () => {
        return modal({
            name: "default",
            title: "Детали маршрута",
            windowMod: "wide",
            CustomBody: RouteDetails,
            bodyData: { route },
        });
    };
    return (
        <>
            <div className="show-bid__section-header">
                <span className="d-flex">
                    Платные участки маршрута
                    <Tooltip overlay="Детали маршрута">
                        <i className="icon-uEA69-question-circle pl-2 cursor-pointer" onClick={showRouteInfo} />
                    </Tooltip>
                </span>
                {cost > 0 && (
                    <small className="float-right">{formatNumber(cost, { style: "currency", currency: "RUB" })}</small>
                )}
            </div>
            <div className="show-bid__section pt-2">
                {Object.values(groupedTollRoads).map((segment, i) => (
                    <div key={i} className="pl-3 position-relative mb-2">
                        <div className="paid-line" style={{ backgroundColor: segment.color }} />
                        {segment.trackName || "Нет информации о стоимости"} <br />
                        <span className="text-muted">
                            {formatNumber(Math.round(segment.distance / 1000))} км&nbsp;
                            {formatNumber(segment.cost, { style: "currency", currency: "RUB" })}
                        </span>
                    </div>
                ))}
            </div>
        </>
    );
};

export default TollRoads;
